import {
    chatsDeleteRequest,
    chatsGetRequest,
    chatsPostRequest,
    chatsPutRequest,
    sheetServerRequest,
} from '../../apiRequests'

export { submitQueryFeedbackRequest } from './chatFeedbackApi'

export const chat = async (prompt, chatID, inboxID) => {
    const action = {
        action: 'chat',
        prompt,
        chatID,
        inboxID,
    }
    return await sheetServerRequest(action)
}

export const resetChat = async (chatID, inboxID) => {
    const action = {
        action: 'chat',
        chatID,
        inboxID,
        reset: true,
    }
    return await sheetServerRequest(action)
}

export const createChatRequest = async (title) => {
    const data = { title }
    return await chatsPostRequest(data)
}

export const deleteChatRequest = async (chatID, userID, workspaceID) => {
    const path = `/${chatID}?userID=${userID}&workspaceID=${workspaceID}`
    return await chatsDeleteRequest(path)
}

export const getChatMessagesRequest = async (chatID, userID, workspaceID, limit, cursor, order) => {
    const path = `/${chatID}/messages?userID=${userID}&workspaceID=${workspaceID}&limit=${limit}&cursor=${cursor}&order=${order}`
    return await chatsGetRequest(path)
}

export const getChatsRequest = async (userID, workspaceID, limit, cursor) => {
    const path = `?userID=${userID}&workspaceID=${workspaceID}&limit=${limit}&cursor=${cursor}`
    return await chatsGetRequest(path)
}

export const saveMessageRequest = async (chatID, content) => {
    const path = `/${chatID}/messages`
    const data = { content }
    return await chatsPostRequest(data, path)
}

export const updateChatRequest = async (chatID, title) => {
    const path = `/${chatID}`
    const data = { title }
    return await chatsPutRequest(data, path)
}
